import ServiceBase from '@/services/ServiceBase';

const resource = 'api/v1/color';

class TransportColorService extends ServiceBase {
  constructor() {
    super({ resource });
  }
}

export default TransportColorService;



// WEBPACK FOOTER //
// ./src/services/TransportColorService.js